import {useEffect, useState} from 'react'
import {Module} from './types'

/**
 * the list of modules
 *
 * @type {string}
 */
export let modulesList: {[key: string]: Module} = {}

/**
 * Set module loaders [ loadModule, loadApp ]
 *
 * @param {Module} module
 * @returns {void}
 */
export function setModuleLoaders(moduleInfo: Module): void {
  const app = moduleInfo.app

  const module = moduleInfo.module

  // Load module provider
  moduleInfo.loadModule = () => import(`apps/${app}/${module}/provider.ts`)

  // Load app provider
  moduleInfo.loadApp = () => import(`apps/${app}/${app}-provider.ts`)
}

/**
 * Set modules list
 *
 * @param module
 * @returns {void}
 */
export function setModules(module: Module): void {
  for (const entryRoute of module.entry as string[]) {
    modulesList[entryRoute] = module
  }
}

/**
 * Get modules list
 *
 */
export function getModules() {
  return modulesList
}

/**
 * Check if is module exists by the given segment
 *
 * @param {string} Module
 * @returns {boolean}
 */
export function isModuleExists(segment: string): boolean {
  return Boolean(modulesList[segment])
}

export function useLoadAllModules() {
  const [isLoaded, setLoaded] = useState(false)

  const loadedAppsList: any[] = []

  const loadedModulesList: any[] = []

  const modulePaths: any[] = []

  for (const module in modulesList) {
    const moduleInfo = modulesList[module]

    // load main provider app
    moduleInfo.loadApp && modulePaths.push(moduleInfo.loadApp())

    // load module provider m
    moduleInfo.loadModule && modulePaths.push(moduleInfo.loadModule())

    loadedAppsList.push(moduleInfo.app)

    loadedModulesList.push(moduleInfo.module)
  }

  useEffect(() => {
    Promise.all(modulePaths).then(() => {
      setLoaded(true)
    })
  }, [])

  return {isLoaded}
}
